import { createSlice } from "@reduxjs/toolkit";
import {
  setEventcustomisation,
  setLogoutEventcustomisation,
} from "./eventcustomisationsSlice";
import { setTemplate, setLogoutTemplate } from "./templateSlice";

const initialState = {
  eventcustomisations: [],
  templates: [],
  contentAI: [
    {
      id: "content-ai",
      name: "Content AI",
      imageUrl:
        "https://storage.googleapis.com/content_ai_bucket_elhitech/content/contentAI placeholder.png",
    },
  ],
  dataToDisplay: [],
};

export const dataToDisplaySlice = createSlice({
  name: "dataToDisplay",
  initialState,
  reducers: {
    updateDataToDisplay: (state) => {
      state.dataToDisplay = [
        ...state.eventcustomisations,
        ...state.templates,
        ...state.contentAI,
      ];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setEventcustomisation, (state, action) => {
        state.eventcustomisations = action.payload;
        state.dataToDisplay = [
          ...state.eventcustomisations,
          ...state.templates,
          ...state.contentAI,
        ];
      })
      .addCase(setTemplate, (state, action) => {
        state.templates = action.payload;
        state.dataToDisplay = [
          ...state.eventcustomisations,
          ...state.templates,
          ...state.contentAI,
        ];
      })
      .addCase(setLogoutEventcustomisation, (state) => {
        state.eventcustomisations = [];
        state.dataToDisplay = [
          ...state.eventcustomisations,
          ...state.templates,
          ...state.contentAI,
        ];
      })
      .addCase(setLogoutTemplate, (state) => {
        state.templates = [];
        state.dataToDisplay = [
          ...state.eventcustomisations,
          ...state.templates,
          ...state.contentAI,
        ];
      });
  },
});

export const { updateDataToDisplay } = dataToDisplaySlice.actions;
export default dataToDisplaySlice.reducer;
